import styled, { css } from 'styled-components'

import FormikForm from '../../form/FormikForm'
import FormSubmitButton from '../../form/FormSubmitButton'
import FormOTP from '../../form/FormOTP'
import FormErrors from '../../form/FormErrors'

export const Form = styled(FormikForm)``

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Title = styled.p`
  width: 100%;
  ${({ theme }) => theme.textStyles.display};
  text-align: center;
`

export const FieldTitle = styled.p`
  width: 100%;
  ${({ theme }) => theme.fonts.BBCondBold};
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 36px;
`

export const FieldDescription = styled.p`
  margin-top: 4px;
  width: 100%;
  text-align: center;
  ${({ theme }) => theme.textStyles.body};
`

export const FieldFormOTP = styled(FormOTP)`
  margin-top: 5px;
  width: 100%;
  align-items: center;
`

export const Errors = styled(FormErrors)`
  margin-top: 36px;
  text-align: center;
`

export const Resend = styled.p<{ $disabled: boolean }>`
  margin-top: 36px;
  text-align: center;
  ${({ theme }) => theme.fonts.BBRegular};
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;

  ${(p) =>
    p.$disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`

export const Center = styled.div`
  display: flex;
  justify-content: center;
`

export const SubmitButton = styled(FormSubmitButton)`
  display: inline-flex;
  margin: 30px auto auto auto;
`
